export default __webpack_public_path__ + "static/media/future_messages_bg.17703248.png";